"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _r10CommonComponents = require("r10-common-components");
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _queryString = _interopRequireDefault(require("query-string"));
var _jsonpath = _interopRequireDefault(require("jsonpath"));
var _Header = _interopRequireDefault(require("./Header"));
var _AddonDetails = _interopRequireDefault(require("./AddonDetails"));
var _Summary = _interopRequireDefault(require("./Summary"));
var _selector = require("../selectors/selector");
var _Actions = require("../actions/Actions");
var _fullScreenSpinner = _interopRequireDefault(require("../utils/fullScreenSpinner"));
var _useTranslation = _interopRequireDefault(require("../hooks/useTranslation"));
var _useConfig2 = _interopRequireDefault(require("../hooks/useConfig"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function App() {
  var _bundleDetailsErrorHa;
  var t = (0, _useTranslation.default)();
  var dispatch = (0, _reactRedux.useDispatch)();
  var history = (0, _reactRouterDom.useHistory)();
  var _useParams = (0, _reactRouterDom.useParams)(),
    id = _useParams.id;
  var _useLocation = (0, _reactRouterDom.useLocation)(),
    search = _useLocation.search;
  var searchParams = _queryString.default.parse(search);
  var autoRenew = searchParams['auto-renew'];
  var _useConfig = (0, _useConfig2.default)(),
    bundleNamePath = _useConfig.bundleNamePath,
    bundleDetailsEndPoint = _useConfig.bundleDetailsEndPoint,
    _useConfig$bundleDeta = _useConfig.bundleDetailsErrorHandling,
    bundleDetailsErrorHandling = _useConfig$bundleDeta === void 0 ? {
      errorList: []
    } : _useConfig$bundleDeta;
  var bundleDetails = (0, _reactRedux.useSelector)(_selector.getBundleDetails);
  var isLoading = (0, _reactRedux.useSelector)(_selector.getLoadingState);
  var hasError = (0, _reactRedux.useSelector)(_selector.hasErrorSelector);
  var fetchingBundleError = (0, _reactRedux.useSelector)(_selector.fetchingBundleErrorSelector);
  var bundleName = '';
  if (bundleDetails && bundleNamePath) {
    bundleName = _jsonpath.default.value(bundleDetails, bundleNamePath);
  }
  (0, _react.useEffect)(function () {
    return function () {
      return dispatch((0, _Actions.resetErrors)());
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (isLoading) return;
    dispatch((0, _Actions.getBundleDetailsRequest)({
      id: id,
      bundleDetailsEndPoint: bundleDetailsEndPoint,
      bundleDetailsErrorHandling: bundleDetailsErrorHandling
    }));
  }, [id]);
  if (isLoading) return /*#__PURE__*/_react.default.createElement(_fullScreenSpinner.default, {
    spinnerTxt: t('apiCall')
  });
  var mapErrorButtonsActions = function mapErrorButtonsActions(_ref) {
    var action = _ref.action,
      redirectionURL = _ref.redirectionURL;
    switch (action) {
      case 'redirection':
        return function () {
          return history.push(redirectionURL);
        };
      case 'retry':
      default:
        return function () {
          return dispatch((0, _Actions.getBundleDetailsRequest)({
            id: id,
            bundleDetailsEndPoint: bundleDetailsEndPoint,
            bundleDetailsErrorHandling: bundleDetailsErrorHandling
          }));
        };
    }
  };
  if (hasError) return bundleDetailsErrorHandling === null || bundleDetailsErrorHandling === void 0 ? void 0 : (_bundleDetailsErrorHa = bundleDetailsErrorHandling.errorList.filter(function (_ref2) {
    var type = _ref2.type;
    return type === fetchingBundleError;
  })) === null || _bundleDetailsErrorHa === void 0 ? void 0 : _bundleDetailsErrorHa.map(function (err) {
    return /*#__PURE__*/_react.default.createElement(_r10CommonComponents.ErrorModal, _extends({
      key: err.title,
      icon: err.icon,
      title: t(err.title),
      description: t(err.description),
      buttonText: t(err.primaryButton.text),
      buttonAction: mapErrorButtonsActions(err.primaryButton),
      hasCloseIcon: false,
      isOpen: true,
      titleTestId: "addon-details-error-".concat(err.type, "-title"),
      descriptionTestId: "addon-details-error-".concat(err.type, "-description"),
      actionButtonTestId: "addon-details-error-".concat(err.primaryButton.text, "-button")
    }, err.secondaryButton ? {
      secondaryButton: {
        text: t(err.secondaryButton.text),
        onClick: mapErrorButtonsActions(err.secondaryButton),
        dataTestId: "addon-details-error-".concat(err.secondaryButton.text, "-button")
      }
    } : {}));
  });
  return bundleDetails && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Grid, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    noGutters: true,
    align: "center",
    justify: "center",
    marginTop: 7
  }, /*#__PURE__*/_react.default.createElement(_Header.default, {
    bundleName: bundleName
  })), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    noGutters: true,
    align: "center",
    justify: "center",
    marginTop: 9,
    marginBottom: 7
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    colLg: 9,
    col: 12
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: "center",
    align: "start"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    colMd: 7,
    col: 12
  }, /*#__PURE__*/_react.default.createElement(_AddonDetails.default, {
    bundleDetails: bundleDetails
  })), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    colMd: 5,
    col: 12
  }, /*#__PURE__*/_react.default.createElement(_Summary.default, {
    bundleDetails: bundleDetails,
    autoRenew: (autoRenew === null || autoRenew === void 0 ? void 0 : autoRenew.toLowerCase()) === 'true',
    bundleName: bundleName,
    bundleId: id
  }))))));
}
var _default = App;
exports.default = _default;